import { LOGIN_PATH, REGISTER_PATH } from '../components/LegalLinks';
import { AppViewIds } from './appViewIds';
import {
    Lock as LockIcon,
    UserPlus as UserPlusIcon,
    Users as UsersIcon,
    Upload as UploadIcon,
    Film as FilmIcon,
    Search as SearchIcon,
    Inbox as InboxIcon,
    Clipboard as ClipboardIcon,
    FileText as FileTextIcon,
    Layers as LayersIcon,
    BookOpen as BookOpenIcon,
    Book as BookIcon,
    List as ListIcon,
    Paperclip as PaperclipIcon,
    Thermometer as ThermometerIcon,
    Sliders as SlidersIcon,
    Smartphone as AppManagementIcon,
    Download as DownloadIcon,
    Layout as LayoutIcon,
} from 'react-feather';

export const PLANS_PATH = '/plans';

/**
 * Registry keyed by AppViewId Guid string.
 * Sync test validates keys against AppViewIds.cs NavRoutedViews.
 */
export const viewRegistry = {
    [AppViewIds.Plans]: { route: PLANS_PATH, title: 'Plans', icon: FileTextIcon, isNavItem: true, navGroup: 'Company' },
    [AppViewIds.PlanInbox]: { route: '/planInbox', title: 'Plan Inbox', icon: LayersIcon, isNavItem: true, navGroup: 'Company' },
    [AppViewIds.Upload]: { route: '/upload', title: 'Upload Plan', icon: UploadIcon, isNavItem: true, navGroup: 'Company' },
    [AppViewIds.Surveys]: { route: '/surveys', title: 'Surveys', icon: LayoutIcon, isNavItem: true, navGroup: 'Company' },
    [AppViewIds.ReceivedEstimates]: { route: '/InvoicesToMe', title: 'Received Invoices', icon: BookOpenIcon, isNavItem: true, navGroup: 'Billing' },
    [AppViewIds.CustomerEstimates]: { route: '/CustomerEstimates', title: 'Customer Estimates', icon: BookIcon, isNavItem: true, navGroup: 'Billing' },
    [AppViewIds.FindProcessor]: { route: '/findProcessor', title: 'Find Processor', icon: SearchIcon, isNavItem: true, navGroup: 'Company' },
    [AppViewIds.Customers]: { route: '/customers', title: 'Customer Management', icon: InboxIcon, isNavItem: true, navGroup: 'Company' },
    [AppViewIds.Contacts]: { route: '/contacts', title: 'Processor Contacts', icon: UsersIcon, isNavItem: true, navGroup: 'Company' },
    [AppViewIds.Instructions]: { route: '/instructions', title: 'Tutorial', icon: FilmIcon, isNavItem: true, navGroup: 'General' },
    [AppViewIds.AppDownload]: { route: '/AppDownload', title: 'App Download', icon: DownloadIcon, isNavItem: true, navGroup: 'General' },
    [AppViewIds.Account]: { route: '/account', title: 'Account', icon: UsersIcon, isNavItem: false, navGroup: 'General' },
    [AppViewIds.CompaniesViewer]: { route: '/companiesViewer', title: 'Companies', icon: ListIcon, isNavItem: true, navGroup: 'Super Admin' },
    [AppViewIds.Configuration]: { route: '/Configuration', title: 'Botmark Config', icon: SlidersIcon, isNavItem: true, navGroup: 'Super Admin' },
    [AppViewIds.RulerCreator]: { route: '/RulerCreator', title: 'Rulers', icon: ThermometerIcon, isNavItem: true, navGroup: 'Super Admin' },
    [AppViewIds.Licensing]: { route: '/licensing', title: 'Licensing', icon: ClipboardIcon, isNavItem: true, navGroup: 'Super Admin' },
    [AppViewIds.BotmarkInvoiceTable]: { route: '/BotmarkInvoiceTable', title: 'Botmark Invoices', icon: BookIcon, isNavItem: true, navGroup: 'Super Admin' },
    [AppViewIds.AppManagement]: { route: '/AppManagement', title: 'App Management', icon: AppManagementIcon, isNavItem: true, navGroup: 'Super Admin' },
    [AppViewIds.PdfUpload]: { route: '/PDFupload', title: 'PDF/Tutorial Upload', icon: PaperclipIcon, isNavItem: true, navGroup: 'Super Admin' },
    [AppViewIds.AccountUserInfo]: { route: null, title: 'Account: User Info', icon: null, isNavItem: false, navGroup: 'Tabs' },
    [AppViewIds.AccountCompany]: { route: null, title: 'Account: Company', icon: null, isNavItem: false, navGroup: 'Tabs' },
    [AppViewIds.AccountEmployees]: { route: null, title: 'Account: Employees', icon: null, isNavItem: false, navGroup: 'Tabs' },
    [AppViewIds.AccountPriceOptions]: { route: null, title: 'Account: Price Options', icon: null, isNavItem: false, navGroup: 'Tabs' },
    [AppViewIds.AccountLicenses]: { route: null, title: 'Account: Licenses', icon: null, isNavItem: false, navGroup: 'Tabs' },
    [AppViewIds.AccountRulers]: { route: null, title: 'Account: Rulers', icon: null, isNavItem: false, navGroup: 'Tabs' },
    [AppViewIds.SurveysReceived]: { route: null, title: 'Surveys: Received', icon: null, isNavItem: false, navGroup: 'Tabs' },
    [AppViewIds.SurveysSent]: { route: null, title: 'Surveys: Sent', icon: null, isNavItem: false, navGroup: 'Tabs' },
    [AppViewIds.PlansAdmin]: { route: null, title: 'Plans: Admin', icon: null, isNavItem: false, navGroup: 'Company' },
    [AppViewIds.PlanInboxAdmin]: { route: null, title: 'Plan Inbox: Admin', icon: null, isNavItem: false, navGroup: 'Company' },
};

export const loginNavItems = [
    { href: LOGIN_PATH, icon: LockIcon, title: 'Login' },
    { href: REGISTER_PATH, icon: UserPlusIcon, title: 'Register' },
];

export function getNavItemsForRegistry() {
    return Object.entries(viewRegistry)
        .filter(([, entry]) => entry.isNavItem)
        .map(([appViewId, entry]) => ({
            appViewId,
            href: entry.route,
            title: entry.title,
            icon: entry.icon,
            navGroup: entry.navGroup,
        }));
}

export function getRouteByAppViewId(appViewId) {
    return viewRegistry[appViewId]?.route ?? null;
}
